import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";

export const statusCategories = [
  {
    name: "Open",
    background: BUTTON_TYPES.DROPDOWN_BACKGROUND_TEXT_LIGHT_LIST,
    backgroundHexcode: "#666a84",
    color: "--system-colour-43",
    isValidCategory: true,
  },
  {
    name: "In Progress",
    background: BUTTON_TYPES.DROPDOWN_BACKGROUND_YELLOW_LIST,
    backgroundHexcode: "#ffcf55",
    color: "--system-colour-43",
    isValidCategory: true,
  },
  {
    name: "Closed - Positive",
    background: BUTTON_TYPES.DROPDOWN_BACKGROUND_GREEN_LIST,
    backgroundHexcode: "#45cf80",
    color: "--system-colour-43",
    isValidCategory: true,
  },
  {
    name: "Closed - Negative",
    background: BUTTON_TYPES.DROPDOWN_BACKGROUND_RED_LIST,
    backgroundHexcode: "#e75555",
    color: "--system-colour-43",
    isValidCategory: true,
  },
  {
    name: null,
    background: BUTTON_TYPES.DROPDOWN_BACKGROUND_LIST,
    backgroundHexcode: "#ecf3fe",
    color: "--system-colour-43",
    isValidCategory: false,
  },
  {
    name: "0",
    background: BUTTON_TYPES.DROPDOWN_BACKGROUND_ROYAL_BLUE_LIST,
    backgroundHexcode: "#0006A2",
    color: "--system-colour-43",
    isValidCategory: false,
  },
  {
    name: "Varies",
    background: BUTTON_TYPES.BACKGROUND_BUTTON,
    backgroundHexcode: "#d4e8fa",
    color: "var(--primary-text)",
    isValidCategory: false,
  },
];
